import { Card, CardContent, Tab, Tabs } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { CameraItemDto } from "~/api/GeneratedApi";
import { CameraRecord } from "~/components/camera-video/CameraRecord";
import { CameraVideo } from "~/components/camera-video/CameraVideo";
import { TabPanel, useTabStyles } from "~/components/GenericTab";
import { useIsMobile } from "~/utils/hooks/useIsMobile";

export const CameraViewTab = ({
  camera,
}: {
  camera: CameraItemDto;
}): JSX.Element => {
  const { t } = useTranslation("ais-routers");
  const [tab, setTab] = React.useState("live-stream");
  const isMobile = useIsMobile();
  const tabs = [
    {
      id: "live-stream",
      label: t("recordedStream:liveTab"),
    },
    {
      id: "stream-record",
      label: t("recordedStream:recordTab"),
    },
  ];
  const classes = useTabStyles();
  const handleChange = (_event: React.SyntheticEvent, newValue: string) => {
    setTab(newValue);
  };
  return (
    <Card sx={{ mt: 2 }}>
      <Tabs
        TabIndicatorProps={{ className: classes.indicator }}
        indicatorColor="secondary"
        value={tab}
        onChange={handleChange}
        variant={isMobile ? "scrollable" : undefined}
        scrollButtons="auto"
        sx={{ maxWidth: "100%" }}
      >
        {tabs.map((ta) => (
          <Tab
            // disabled={ta.id === "stream-record"}
            key={ta.id}
            value={ta.id}
            label={ta.label}
            // disabled={t.disabled ?? false}
          />
        ))}
      </Tabs>
      <CardContent>
        <TabPanel index="live-stream" value={tab}>
          <CameraVideo camera={camera} />
        </TabPanel>
        <TabPanel index="stream-record" value={tab}>
          <CameraRecord camera={camera} />
        </TabPanel>
      </CardContent>
    </Card>
  );
};
